module.exports = __webpack_public_path__ + "47a9ada2f9a1dfa53112f363aaac7bc9.svg";